import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  REQUEST_MESSAGE_COUNT,
  REQUEST_MESSAGE_COUNT_SUCCESS,
  REQUEST_MESSAGE_COUNT_ERROR,
} from '../constants/MessageConstants';
import { parseMessageCountResponse } from '../parsers/MessageParser';

class MessageActionCreator {
  /**
   * Action to fetch the current New Secure Messages count from the secure-messages-service
   */
  getMessageCount() {
    AppDispatcher.handleViewAction({
      actionType: REQUEST_MESSAGE_COUNT,
    });
  }

  /**
   * Dispatches a a success action with the count of "NEW" messages from the
   * getMessageCount server response.
   * @param  {object} response success response
   */
  handleMessageCountSuccess(response, status) {
    // In the event of a 204 (No Content, AKA No messages) return 0.
    AppDispatcher.handleServerAction({
      actionType: REQUEST_MESSAGE_COUNT_SUCCESS,
      data: status === 204 ? 0 : parseMessageCountResponse(response),
    });
  }

  /**
   * Action to handle service error response
   * @param  {object} error  error response
   */
  handleMessageCountError() {
    AppDispatcher.handleServerAction({
      actionType: REQUEST_MESSAGE_COUNT_ERROR,
    });
  }
}

export default new MessageActionCreator();
